// Peças compartilhadas das abas do Plano de ação.
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import type { ReactNode } from 'react';
import type { CicloCompleto, Conta, Papel } from './api';
import { dia } from './regras';

/** Tudo que cada aba precisa: os dados, "hoje" e como gravar. */
export interface Contexto {
  dados: CicloCompleto;
  hoje: string;
  /** Roda a gravação; devolve true se deu certo. Já trata o 409 e recarrega a tela. */
  salvar: (fn: () => Promise<unknown>, ok?: string) => Promise<boolean>;
  contas: Conta[];
}

export const FORMATO_DATA = 'DD/MM/YYYY';

/** Seletor de data dd/mm/aaaa. Entra e sai como "AAAA-MM-DD" puro (não desloca por fuso). */
export function CampoData({ valor, onChange, placeholder }: { valor: string | null; onChange: (v: string | null) => void; placeholder?: string }) {
  const d = dia(valor);
  return (
    <DatePicker
      style={{ width: '100%' }} format={FORMATO_DATA} placeholder={placeholder || 'dd/mm/aaaa'}
      value={d ? dayjs(d) : null}
      onChange={(x) => onChange(x ? x.format('YYYY-MM-DD') : null)}
    />
  );
}

export function nomeDoPapel(dados: { papeis: Papel[] }, papel: string | null | undefined): string {
  if (!papel) return '—';
  const p = dados.papeis.find((x) => x.papel === papel);
  if (!p) return papel;
  return p.nome ? `${p.nome} (${p.rotulo})` : p.rotulo;
}

export function Rotulo({ children }: { children: ReactNode }) {
  return <div style={{ fontSize: 12, color: '#8c8c8c', marginBottom: 2 }}>{children}</div>;
}
